import { baseBreakpoints } from '../../base/tokens/breakpoints'

// should match base values until we have a need for different values
export const journeyUiBreakpoints = { ...baseBreakpoints }
